import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import About from "../pages/About";
import Terms from "../pages/Terms";
import Contact from "../pages/Contact";
import GetAuth from "../pages/GetAuth";
import NotFound from "../pages/NotFound";
import HomePage from "../pages/Home";
import Special from "../users/Special";
import Loan from "../pages/Loans";
import NewInvestment from "../pages/NewInvestment";
import PlanDetail from "../pages/PlanDetail";
import TransactionDetail from "../users/TransactionDetail";


// ScrollToTop component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const NotUser = ({ setUser }) => {
  // Expect setUser as a prop if needed for GetAuth

  return (
    <div className="not-user">
      {/* Place ScrollToTop outside Routes so it always runs */}
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/investments/:planKey" element={<PlanDetail user={null} />} />
        <Route path="/investments" element={<NewInvestment user={null} />} />
            <Route path="transactions/:userId/:index" element={<TransactionDetail user={null} />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/login" element={<GetAuth setUser={setUser} />} />
        <Route
          path="/account/:referrerId"
          element={<GetAuth setUser={setUser} />}
        />
        <Route path="/loans" element={<Loan />} />
        <Route path="/special" element={<Special />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default NotUser;
